export function getEnvInfo() {
    return `env:browser ${window.navigator.userAgent}`;
}
